export enum OrgInviteErrorType {
    INVALID_EMAIL_FORMAT= 'INVALID_EMAIL_FORMAT',
    ALREADY_ORG_MEMBER = 'ALREADY_ORG_MEMBER',
    ALREADY_INVITED = 'ALREADY_INVITED',
    INSUFFICIENT_PERMISSION = 'INSUFFICIENT_PERMISSION',
    ACCOUNT_MISMATCH = 'ACCOUNT_MISMATCH'
}